import React from 'react';
import { AnnouncementBanner } from '../Feature/Home/AnnouncementBanner';
import BackgroundVideoSection from '../Feature/Home/BackgroundVideoSection';
import CommunityFunSection from '../Feature/Home/CommunityFunctions';
import { HeroSection } from '../Feature/Home/HeroSection';
import JoinCommunity from '../Feature/Home/JoinCommunity';
import LocationAndHours from '../Feature/Home/LocationAndHours';
import ProgramsSection from '../Feature/Home/ProgramsSection';
import { COLORS } from '../Constants/styles';
// import ProgramsSection from '../Feature/ProgramsCard';

// Define functional component for Home page

const Home: React.FC = () => {
  return (
    <div style={{ color:COLORS.pureBlack,  }}>
      <HeroSection />
      <AnnouncementBanner />
      <ProgramsSection />
      <BackgroundVideoSection />
      <CommunityFunSection />
      <LocationAndHours />
      <JoinCommunity />
      {/* <FooterSection />  */}
    </div>
  );
};

export default Home;
